import { render, staticRenderFns } from "./serviceBook.vue?vue&type=template&id=f4e0f218&"
import script from "./serviceBook.vue?vue&type=script&lang=js&"
export * from "./serviceBook.vue?vue&type=script&lang=js&"
import style0 from "./serviceBook.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports